module.exports = __webpack_public_path__ + "img/device-android.0d102d42.svg";